export default class FooterNewsletters {
    constructor(elm, args) {
        if (elm.querySelectorAll('form').length === 0) return;

        this.elm = elm;
        this.args = args;
        this.form = elm.querySelector('form');
        this.events();
    }

    events() {
        this.form.addEventListener('submit', e => {
            e.preventDefault();

            if (this.validation()) {
                this.send();
            }
        });
    }

    setError(elm, msg) {
        console.log('setError', elm, msg)
        elm.parentNode.querySelector('.invalid-feedback')?.remove();

        const invalidElm = document.createElement('div');
        invalidElm.classList.add('invalid-feedback', 'd-block');
        invalidElm.innerText = msg;
        elm.parentNode.appendChild(invalidElm);
        const inputField = elm.parentNode.querySelector('input');
        inputField.classList.add('invalid');

        if (window.innerWidth < 992) {
            const label = elm.parentNode.querySelector('label');
            label.style.bottom = '40px';
        }
    }

    validation() {
        let valid = true;

        const name = this.form.querySelector('[name=name]');
        if (name.value === '') {
            valid = false;
            this.setError(name, this.args.name);
        } else {
            name.parentNode.querySelector('.invalid-feedback')?.remove();
        }

        const email = this.form.querySelector('[name=email]');
        if (email.value === '') {
            valid = false;
            this.setError(email, this.args.email);
        } else if (!/^\s*[_a-z0-9-A-Z-æøåÆØÅ]+(\.[_a-z0-9-A-Z-æøåÆØÅ]+)*@[a-z0-9-A-Z-]+(\.[a-z0-9-A-Z-]+)*(\.[a-z]{2,10})\s*$/.test(email.value)) {
            valid = false;
            this.setError(email, this.args.emailInvalid);
        } else {
            email.parentNode.querySelector('.invalid-feedback')?.remove();
            email.classList.remove('invalid')
        }

        const accept = this.form.querySelector('[name=accept]');
        if (!accept.checked) {
            valid = false;
            this.setError(accept, this.args.accept);
        } else {
            accept.parentNode.querySelector('.invalid-feedback')?.remove();
            accept.classList.remove('invalid')
        }

        return valid;
    }

    send() {
        const _ = this;
        const data = {};
        for (let i = 0; i < this.form.length; i++) {
            if (this.form[i].name !== '') {
                data[this.form[i].name] = this.form[i].value;
            }
        }

        fetch('/Umbraco/api/newsletter/signup', {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then(stream => {
                console.log(stream);
                if (stream.Result) {
                    _.elm.querySelector('.newsletter__signup').classList.add('d-none');
                    _.elm.querySelector('.newsletter__signedup').classList.remove('d-none');
                } else {
                    for (const item in stream.Errors) {
                        const elm = _.form.querySelector(`[name=${item}]`);
                        if (elm) {
                            _.setError(elm, stream.Errors[item]);
                        } else {
                            console.log(stream.Errors[item]);
                        }
                    }
                }
            });
    }
}
